import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {APIController} from './API/APIController'
import {Calculator} from "./calculator";
import {priceController} from "./priceController";
import { fanObjParamsManager } from "./fanObjParamsManager";
import {Notifications} from "./notifications";
import './globals'
import BrowserChecker from "./browserChecker";
import {ClientTable, Event} from 'vue-tables-2';

import $ from 'jquery'

if (window.location.href.includes('verify_user') && BrowserChecker.getBrowser().name !== 'Chrome') {
    let userHash = BrowserChecker.parseGetParameter('hash');
    if (userHash) {
        document.getElementById("app").remove();
        let formData = new FormData();
        formData.append('hash', userHash);
        APIController.verifyUser(formData)
            .then((res) => {
                let text;
                if (res.data === true) {
                    text = 'User account verified successfully';
                } else if (res.data === 'no_token_registered') {
                    text = 'This token does not exist';
                } else if (res.data === 'token_already_verified') {
                    text = 'Token has already been verified';
                }
                document.getElementById('verification-text').innerHTML = text;
                document.getElementsByClassName('verification-notification')[0].classList.add('visible');
            });
        throw new Error('This browser is not supported');
    }
}

Vue.config.productionTip = false;

Vue.component('custom-header', () => import('./components/top/Top.vue'));

Vue.component('custom-footer', () => import('./components/bottom/Bottom.vue'));

Vue.component('chrome', () => import('vue-color/src/components/Chrome.vue'));


const eventHub = new Vue(); // Single event hub

// Distribute to components using global mixin
Vue.mixin({
    data: function () {
        return {
            eventHub: eventHub
        }
    }
});

Vue.prototype.$apiController = APIController;
Vue.prototype.$tableEvent = Event;
Vue.prototype.$calculator = Calculator;
Vue.prototype.$fanObjParamsManager = fanObjParamsManager;
Vue.prototype.$priceController = priceController;
Vue.prototype.$notifications = Notifications;

let options = {
    preserveState: true
};

let useVuex = true;
// let remote = require('electron').remote;
let theme = "bootstrap3";
let template = "default";
Vue.use(ClientTable, options, useVuex, theme, template);
window.$ = window.jQuery = require('jquery');

window.mouseDown = false;

document.body.onmousedown = function () {
    window.mouseDown = true;
}
document.body.onmouseup = function () {
    window.mouseDown = false;
}

loadApplication();

function loadApplication() {

    if (!store.state.debuMode) {
        APIController.getLanguagesList().then(function (languages) {
                let languagesData = APIController.manageReturnedData(languages, []);
                LoadLanguagesToStore(languagesData);

                APIController.getTranslationsList().then(function (translations) {
                        let translationsData = APIController.manageReturnedData(translations, []);
                        LoadTranslationsToStore(translationsData);

                        new Vue({
                            router,
                            store,
                            render: h => h(App)

                        }).$mount('#app');

                        APIController.loadRequiredData(store).then((res)=>{
                            window.localStorage.setItem('application_data_loaded', true);
                        });
                    }.bind(this)
                );
            }.bind(this)
        );
    } else {
        new Vue({
            router,
            store,
            render: h => h(App)

        }).$mount('#app');
    }
}


function LoadLanguagesToStore(languages) {
    store.state.activeLang = null;
    store.state.languages = [];
    let firstLanguage = null;
    let activeLangSet = false;

    let browserLanguage = navigator.language.slice(0, 2);
    let foundLanguage = languages.find(x => x.code.toLocaleLowerCase() === browserLanguage);

    for (let language of languages) {
        let languageElement = {
            id: language['id'],
            name: language['code'],
            imgSrc: language['flag'],
        };


        if (foundLanguage && !localStorage['activeLang']) {

            firstLanguage = {id: foundLanguage['id'], name: foundLanguage['code'], imgSrc: foundLanguage['flag']};

        } else if (localStorage['activeLang'] == languageElement['id']) {

            localStorage.setItem('activeLang', languageElement['id']);
            store.state.activeLang = languageElement;
            activeLangSet = true;

        }

        if (localStorage['activeLang'] !== languageElement['id']) {
            languageElement['active'] = false;
            store.state.languages.push(languageElement);
        }

        if (firstLanguage === null) {
            firstLanguage = languageElement;
        }
    }

    if (!activeLangSet && firstLanguage != null) {
        store.state.languages = store.state.languages.filter((element) => {
            if (element.id !== firstLanguage['id']) return element;
        });
        localStorage.setItem('activeLang', firstLanguage['id']);
        store.state.activeLang = firstLanguage;
    }
}

function LoadTranslationsToStore(translations) {
    store.state.translations = translations;
}

export default {}
